export default [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'devicCode',
    key: 'deviceCode',
    width: 200
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 460
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 230
  },
  {
    zh: '平均频率(Hz)',
    en: 'Avg Frequency(Hz)',
    dataIndex: 'avgFrequency',
    key: 'avgFrequency'
  },
  {
    zh: '上限频率(Hz)',
    en: 'Rated Frequency(Hz)',
    dataIndex: 'ratedFrequency',
    key: 'ratedFrequency'
  },
  {
    zh: '主机转速(%)',
    en: 'Machine Speed',
    dataIndex: 'machineSpeed',
    key: 'machineSpeed'
  },
  {
    zh: '空滤报警值',
    en: 'Air Filter Element Value',
    dataIndex: 'airFilterElementValue',
    key: 'airFilterElementValue'
  },
  {
    zh: '空滤运行时间',
    en: 'Air Filter Element Run Time',
    dataIndex: 'airFilterElementRunTime',
    key: 'airFilterElementRunTime'
  },
  {
    zh: '占比',
    en: 'Percentage',
    dataIndex: 'percentage',
    key: 'percentage'
  }
]